import react, { useEffect, useState } from 'react';
import { Box, Tabs, Tab, Divider, Typography, CircularProgress } from '@mui/material';
import Section from './Components/Section';
import SubSection from './Components/SubSection';
import States from './Subscription/States';
import ModulesActivated from './Subscription/ModulesActivated';
import PrimaryBusiness from './Subscription/PrimaryBusiness';
import CustomerType from './Advanced/CustomerType';
import ContactType from './Advanced/ContactType';
import LocationType from './Advanced/LocationType';
import EmployeeType from './Advanced/EmployeeType';
import EmployeeStatus from './Advanced/EmployeeStatus';
import PersonalInformation from './General/PersonalInformation';
import EmploymentInformation from './General/EmploymentInformation';
import EmployeeTaskType from './General/EmployeeTaskType';
import ViewEmployeeRelationship from './General/ViewEmployeeRelationship';
import CaregiverPreferences from './General/CaregiverPreferences';
import TaskType from './Advanced/TaskType';
import IndividualSettings from './Advanced/IndividualSettings';
import Workflow from './Advanced/Workflow';
import EvvProcedure from '../Settings/SettingsAndConfg/EvvProcedure/EvvProcedure';
import TaskBillingRatesGrid from './SettingsAndConfg/TaskBillingRates';
import CompanyInformation from './Agency/CompanyInformation';
import Office from './Agency/Office';
import SalaryType from './Agency/SalaryType';
import PayrollFrequency from './Agency/PayrollFrequency';
import StartOfTheWeek from './Agency/StartOfTheWeek';
import Payer from './Agency/Payer';
import AgencySettings from './Agency/AgencySettings';
import Compliance from './Agency/Compliance';
import ClientSurvey from './Agency/ClientSurvey';
import Resource from './Agency/Resource';
import Scheduler from './Agency/Scheduler';
import SecureCommunication from './Agency/SecureCommunication';
import SecureCommunication2 from './General/SecureCommunication2';
import Form from './Advanced/Form';
import ccs from 'countrycitystatejson';
import normalize from 'us-states-normalize';
import axios from 'axios';
import { APIURL } from '../../config';
import BillingInformation from './Billing/BillingInformation';
import BillingSettings from './Billing/BillingSettings';
import Provider from './Billing/Provider';
import PayerInformationv2 from './Billing/PayerInformationv2';
import HomePageLayout from './UserExperience/HomePageLayout';
import Programs from './Programs/Programs';
import { FormControlLabel, Checkbox, Radio, RadioGroup } from '@mui/material';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import EmpType from './Advanced/EmpType';
import Referral from './Agency/Referral';
import CompanyMessages from './Agency/CompanyMessages';
import PaidOutlined from "@mui/icons-material/PaidOutlined";

const Settings = (props) => {
    const [value, setValue] = useState(0);

    // General states
    const [employee, setEmployee] = useState({});
    const [empList, setEmpList] = useState([]);
    const [employeeTaskTypeList, setEmployeeTaskTypeList] = useState([]);
    const [dropdowns, setDropdowns] = useState({});

    // Subscription states
    const [stateList, setStateList] = useState([]);
    const [selectedStates, setSelectedStates] = useState([]);
    const [moduleList, setModuleList] = useState([]);
    const [selectedModules, setSelectedModules] = useState([]);
    const [primaryBusinessType, setPrimaryBusinessType] = useState({});

    // Agency states
    const [companyDetail, setCompanyDetail] = useState({});
    const [payrollData, setPayrollData] = useState([]);
    const [salaryTypeList, setSalaryTypeList] = useState([]);
    const [mileagePayoutRate, setMileagePayoutRate] = useState(null);
    const [frequencyList, setFrequencyList] = useState([]);
    const [selectedFrequency, setSelectedFrequency] = useState(null);
    const [selectedDay, setSelectedDay] = useState(null);
    const [payerList, setPayerList] = useState([]);
    const [resources, setResources] = useState([]);
    const [locations, setLocations] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [schedulerHours, setSchedulerHours] = useState({});
    const [surveyCustomers, setSurveyCustomers] = useState([]);

    useEffect(() => {
        let cancelled = false;
        setSurveyCustomers([]);
        axios.get(APIURL + '/customers/v2/associated', {
            params: {
                company_id: props.comp_id,
                employee_id: props.user.emp_id,
                type: props.user.permissions?.AdminLevelCustomers ? 'Admin' : 'Manager',
                ...(props.selectedProgramId ? { program_id: props.selectedProgramId } : {}),
            },
        }).then(response => {
            if (!cancelled) setSurveyCustomers(response.data || []);
        }).catch(error => console.error('Failed to load survey customers:', error));
        return () => { cancelled = true; };
    }, [props.comp_id, props.user.emp_id, props.user.permissions?.AdminLevelCustomers, props.selectedProgramId]);

    const companySurveyCustomers = surveyCustomers.filter(customer =>
        Number(customer.cus_company_id ?? customer.com_id) === Number(props.comp_id)
    );

    // Billing states
    const [billingDetail, setBillingDetail] = useState([]);
    const [payerDetail, setPayerDetail] = useState({});
    const [credDetail, setCredDetail] = useState({});

    // Employee states

    // Advanced states
    const [customerTypeList, setCustomerTypeList] = useState([]);
    const [contactTypeList, setContactTypeList] = useState([]);
    const [locationTypeList, setLocationTypeList] = useState([]);
    const [employeeTypeList, setEmployeeTypeList] = useState([]);
    const [employeeStatusList, setEmployeeStatusList] = useState([]);
    const [taskTypeList, setTaskTypeList] = useState([]);
    const [adlCatalog, setAdlCatalog] = useState([]);
    const [adlCatalogLoading, setAdlCatalogLoading] = useState(true);
    const [adlCatalogError, setAdlCatalogError] = useState('');
    const [adlLinks, setAdlLinks] = useState({});
    const [adlLinksLoading, setAdlLinksLoading] = useState(true);
    const [adlLinksError, setAdlLinksError] = useState('');
    const [procList, setProcList] = useState([]);
    const [providerList, setProviderList] = useState([]);
    const [officeList, setOfficeList] = useState([]);
    const [formList, setFormList] = useState([]);
    const [subscribedForms, setSubscribedForms] = useState([]);
    const [allForms, setAllForms] = useState([]);
    const [procedureData, setProcedureData] = useState([]);

    const [calendarNotifications, setCalendarNotifications] = useState(false);
    const [mtNA, setMtNA] = useState(false);
    const [mtNamingConvention, setMtNamingConvention] = useState('');
    const [trackEmployeeCost, setTrackEmployeeCost] = useState(false);
    const [identifyAnnualVisit, setIdentifyAnnualVisit] = useState(false);
    const [mtNotification, setMtNotification] = useState(false);
    const [taskNotification, setTaskNotification] = useState(false);
    const [enableAutomaticPayroll, setEnableAutomaticPayroll] = useState(false);
    const [tasksBillableByDefault, setTasksBillableByDefault] = useState(false);
    const [EVVOnly, setEVVOnly] = useState(false);
    const [toleranceVal, setToleranceVal] = useState(null);
    const [createProjectForNewCustomers, setCreateProjectForNewCustomers] = useState(false);
    const [neverExpireCustomerProjects, setNeverExpireCustomerProjects] = useState(false);

    const [mtSubmission, setMtSubmission] = useState(false);
    const [mtRejected, setMtRejected] = useState(false);
    const [mtApproved, setMtApproved] = useState(false);
    const [taskAssigned, setTaskAssigned] = useState(false);
    const [taskStartTimeApproaching, setTaskStartTimeApproaching] = useState(false);
    const [taskEndTimeApproaching, setTaskEndTimeApproaching] = useState(false);
    const [enableMessagingToClients, setEnableMessagingToClients] = useState(false);
    const [enableSoSMessaging, setEnableSoSMessaging] = useState(false);
    const [enableMessagingToContacts, setEnableMessagingToContacts] = useState(false);
    const [missedClockIn, setMissedClockIn] = useState(false);
    const [missedClockOut, setMissedClockOut] = useState(false);

    // Task Configuration states
    const [taskDescriptionIsMandatory, setTaskDescriptionIsMandatory] = useState(false);
    const [timesheetEntryHasNotes, setTimesheetEntryHasNotes] = useState(false);
    const [timesheetEntryType, setTimesheetEntryType] = useState('duration');
    const [taskTravelTimeEnabled, setTaskTravelTimeEnabled] = useState(false);
    const [taskExpensesEnabled, setTaskExpensesEnabled] = useState(false);

    const [mtSubmission2, setMtSubmission2] = useState(false);
    const [mtRejected2, setMtRejected2] = useState(false);
    const [mtApproved2, setMtApproved2] = useState(false);
    const [taskAssigned2, setTaskAssigned2] = useState(false);
    const [taskStartTimeApproaching2, setTaskStartTimeApproaching2] = useState(false);
    const [taskEndTimeApproaching2, setTaskEndTimeApproaching2] = useState(false);

    const [wf_taskCreationDays, setWf_taskCreationDays] = useState(null);

    // User Experience states
    const [layout, setLayout] = useState([]);

    const leftColumnSize = 4;
    const rightColumnSize = 8;

    const [loadingGeneral, setLoadingGeneral] = useState(true);
    const [loadingSubscription, setLoadingSubscription] = useState(true);
    const [loadingAgency, setLoadingAgency] = useState(true);
    const [loadingBilling, setLoadingBilling] = useState(true);
    const [loadingAdvanced, setLoadingAdvanced] = useState(true);
    const [loadingUserExperience, setLoadingUserExperience] = useState(true);

    const pBusinessType = props.user?.comp_settings.find(setting => setting.feature_value === 'primaryBusinessType') ? props.user.comp_settings.filter((setting) => setting.feature_value === "primaryBusinessType")[0].feature_id : -1;

    useEffect(() => {
        console.log(props);
        const loadDataForTab = async () => {
            switch (value) {
                case 0:
                    if (loadingGeneral) {
                        await loadGeneralData();
                        setLoadingGeneral(false);
                    }
                    break;
                case 1:
                    if (loadingSubscription) {
                        await loadSubscriptionData();
                        setLoadingSubscription(false);
                    }
                    break;
                case 2:
                    if (loadingAgency) {
                        await loadAgencyData();
                        setLoadingAgency(false);
                    }
                    break;
                case 3:
                    if (loadingBilling) {
                        await loadBillingData();
                        setLoadingBilling(false);
                    }
                    break;
                case 5:
                    if (loadingAdvanced) {
                        await loadAdvancedData();
                        setLoadingAdvanced(false);
                    }
                    break;
                case 6:
                    if (loadingUserExperience) {
                        await loadUserExperienceData();
                        setLoadingUserExperience(false);
                    }
                    break;
                default:
                    break;
            }
        };

        loadDataForTab();
    }, [value]);

    const loadGeneralData = async () => {
        await getModuleData();
        await getEmployee();
        await getEmployeeTaskTypes();
        await getSecureCommunicationData2();
        // Load more general data if required
    };

    const loadSubscriptionData = async () => {
        await getPrimaryBusinessData();
        await getStateData();
        // Load more subscription data if required
    };

    const loadAgencyData = async () => {
        await getCompanyData();
        await getSalaryTypeData();
        await getFrequencyData();
        await getResourceData();
        await getSchedulerHours();
        await getAgencySettings();
        await getSecureCommunicationData();
        // Load any remaining agency data
    };

    const loadBillingData = async () => {
        await geBillingData();
        // Load more billing data if required
    };

    const loadAdvancedData = async () => {
        await getTaskTypeData();
        await getAdlCatalogData();
        await getAdlLinksData();
        await getContactTypeData();
        await getLocationTypeData();
        await getEmployeeTypeData();
        await getEmployeeStatusData();
        await getCustomerTypeData();
        await getIndividualSettings();
        await getProcedureData();
        await getSubscribedFormData();
        await getWorkflowData();
    };

    const loadUserExperienceData = async () => {
        await getGridLayout();
        await getEmployeeTypeData();
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const getStateData = async () => {
        try {
            let states = ccs.getStatesByShort('US').filter(state => { return state.length > 2 });
            let stateList = await axios.get(APIURL + "/dropdowns/states")
            stateList = stateList.data.states.map(state => {
                if (states.find((s) => s === state.name)) {
                    return { name: state.name, isoCode: normalize(state.isoCode) }
                } else { return null }
            }).filter(state => !!state)
            setStateList(stateList);
            let selectedStates = await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 99 } })
            selectedStates = selectedStates.data?.map(state => {
                return { name: state.feature_value, isoCode: state.state_id }
            })
            setSelectedStates(selectedStates);
        } catch (error) {
            console.error(error);
        }
    }

    const getModuleData = async () => {
        try {
            let modulesList = await axios.get(APIURL + "/config/defaults", { params: { feature_type: "functionality" } })
            setModuleList(modulesList.data);
            console.log(modulesList.data);
            
            let selectedModules = await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_value: "functionality" } })
            selectedModules = selectedModules.data.map(module => {
                return { feature_value: modulesList.data.find((m) => m.feature_id === module.feature_id).feature_value, feature_id: module.feature_id }
            })
            setSelectedModules(selectedModules);
        } catch (error) {
            console.error(error);
        }
    }

    const getPrimaryBusinessData = async () => {
        try {
            let primaryBusinessType = await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_value: "primaryBusinessType" } });
            setPrimaryBusinessType(primaryBusinessType.data[0] || null);
            console.log(primaryBusinessType);

        } catch (error) {
            console.error(error);
        }
    }

    const getCustomerTypeData = async () => {
        try {
            let customerType = await axios.get(APIURL + "/dropdowns/dropdownType/customerTypeList", { params: { comp_id: props.comp_id } });
            setCustomerTypeList(customerType.data);
        } catch (error) {
            console.error(error);
        }
    }

    const getContactTypeData = async () => {
        try {
            let contactType = await axios.get(APIURL + "/dropdowns/dropdownType/contactTypeList", { params: { comp_id: props.comp_id } });
            setContactTypeList(contactType.data);
        } catch (error) {
            console.error(error);
        }
    }

    const getLocationTypeData = async () => {
        try {
            let locationType = await axios.get(APIURL + "/dropdowns/dropdownType/locTypeList", { params: { comp_id: props.comp_id } });
            setLocationTypeList(locationType.data);
        } catch (error) {
            console.error(error);
        }
    }

    const getEmployeeTypeData = async () => {
        try {
            let employeeType = await axios.get(APIURL + "/dropdowns/dropdownType/empTypeList", { params: { comp_id: props.comp_id } });
            setEmployeeTypeList(employeeType.data);
        } catch (error) {
            console.error(error);
        }
    }

    const getEmployeeStatusData = async () => {
        try {
            let employeeStatus = await axios.get(APIURL + "/dropdowns/dropdownType/empStatusList", { params: { comp_id: props.comp_id } });
            setEmployeeStatusList(employeeStatus.data);
        } catch (error) {
            console.error(error);
        }
    }

    const getEmployee = async () => {
        try {
            let empList = await axios.get(APIURL + '/employees', { params: { com_id: props.comp_id } })
            empList.data = props.user.type === 'Manager' ? empList.data.filter((emp) => emp.emp_manager_id === props.user.emp_id || emp.emp_id === props.user.emp_id) : empList.data

            setEmpList(empList.data);
            setEmployee(empList.data.find((emp) => emp.emp_id === props.user.emp_id));

            let dropdowns = {
                employees: {
                    list: (await axios.get(APIURL + '/dropdowns/dropdownType/employeeslist', { params: { comp_id: props.comp_id } })).data,
                    empType: (await axios.get(APIURL + '/dropdowns/dropdownType/empType', { params: { comp_id: props.comp_id } })).data,
                    // empLevel: (await axios.get(APIURL+'/dropdowns/dropdownType/empLevel', {params: {comp_id: this.props.comp_id}})).data,
                    compensationType: (await axios.get(APIURL + '/dropdowns/dropdownType/salaryType', { params: { comp_id: props.comp_id } })).data,
                    empStatus: (await axios.get(APIURL + '/dropdowns/dropdownType/empStatus', { params: { comp_id: props.comp_id } })).data
                }
            }
            setDropdowns(dropdowns.employees);
        } catch (error) {
            console.error(error);
        }
    }

    const getEmployeeTaskTypes = async () => {
        let empTasks = await axios.get(APIURL + "/employees/EmployeeTasks", {
            params: { comp_id: props.comp_id, employee_id: props.user.emp_id },
        });

        let taskTypeList = await axios.get(APIURL + "/dropdowns/dropdownType/fullTaskType", {
            params: { comp_id: props.user.comp_id },
        });

        taskTypeList.data.forEach((type) => {
            if (empTasks.data.find((task) => task.ddID === type.ddID)) {
                taskTypeList.data.find((task) => task.ddID === type.ddID).is_Active = 0
            } else {
                taskTypeList.data.find((task) => task.ddID === type.ddID).is_Active = 1
            }
        })
        setEmployeeTaskTypeList(taskTypeList.data)
    }

    const getTaskTypeData = async () => {
        try {
            let taskType = await axios.get(APIURL + "/dropdowns/dropdownType/taskTypeList", { params: { comp_id: props.comp_id } })
            setTaskTypeList(taskType.data);

            let selectedStates = await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 99 } })
            selectedStates = selectedStates.data?.map(state => {
                return { name: state.feature_value, isoCode: state.state_id }
            })
            setSelectedStates(selectedStates);

            let Procdata = await axios.post(APIURL + '/procedureCodes', { states: selectedStates.map((state) => { return { state_id: state.isoCode } }) })
            setProcList(Procdata.data)

            let subForms = await axios.get(APIURL + '/task_form/subscribed?company_id=' + props.comp_id)
            setFormList(subForms.data)

            let providerData = await axios.get(APIURL + `/company/provider`, { params: { company_id: props.comp_id } });
            setProviderList(providerData.data)

            let officeData = await axios.get(APIURL + `/company/officeLocation`, { params: { company_id: props.comp_id } });
            setOfficeList(officeData.data)

            let payerdata = await axios.get(APIURL + "/payer", { params: { comp_id: props.comp_id } })
            setPayerList(payerdata.data)
        } catch (error) {
            console.error(error);
        }
    }

    const getAdlCatalogData = async () => {
        try {
            setAdlCatalogLoading(true);
            setAdlCatalogError('');
            const response = await axios.get(APIURL + '/adl_tasktype/catalog');
            if (!Array.isArray(response.data)) throw new Error('Unexpected activity catalog response');
            setAdlCatalog(response.data);
        } catch (error) {
            console.error(error);
            setAdlCatalogError(error.response?.data?.message || 'Unable to load activity catalog.');
            setAdlCatalog([]);
        } finally {
            setAdlCatalogLoading(false);
        }
    };

    const getAdlLinksData = async () => {
        try {
            setAdlLinksLoading(true);
            setAdlLinksError('');
            const response = await axios.get(APIURL + '/adl_tasktype', { params: { company_id: props.comp_id } });
            if (!Array.isArray(response.data)) throw new Error('Unexpected activity link response');

            const links = {};
            response.data.forEach(link => {
                const taskTypeId = link.taskType_id ?? link.task_type_id;
                const activityId = link.activity_id ?? link.activityId;
                if (taskTypeId === undefined || taskTypeId === null || activityId === undefined || activityId === null) {
                    return;
                }

                const normalizedTaskTypeId = String(taskTypeId);
                const normalizedActivityId = String(activityId);
                if (!Number.isSafeInteger(Number(normalizedActivityId)) || Number(normalizedActivityId) <= 0) {
                    return;
                }

                links[normalizedTaskTypeId] = links[normalizedTaskTypeId] || { ADL: [], IADL: [] };
                const category = ['ADL', 'IADL'].includes(link.adl_category) ? link.adl_category : 'ADL';
                if (!links[normalizedTaskTypeId][category].includes(normalizedActivityId)) {
                    links[normalizedTaskTypeId][category].push(normalizedActivityId);
                }
            });
            Object.keys(links).forEach((key) => {
                links[key].IADL = [];
            });
            setAdlLinks(links);
        } catch (error) {
            console.error(error);
            setAdlLinksError(error.response?.data?.message || 'Unable to load activity links. Retry before editing them.');
            setAdlLinks({});
        } finally {
            setAdlLinksLoading(false);
        }
    };

    const getIndividualSettings = async () => {
        try {
            let calendarNotificationsSettingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 50 } })).data;
            if (calendarNotificationsSettingsData.length > 0)
                calendarNotificationsSettingsData[0].feature_value === 'true' ? setCalendarNotifications(true) : setCalendarNotifications(false);

            let mtNAData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 52 } })).data;
            if (mtNAData.length > 0)
                mtNAData[0].feature_value === 'true' ? setMtNA(true) : setMtNA(false);

            let mtNamingConventionData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 53 } })).data;
            if (mtNamingConventionData.length > 0)
                setMtNamingConvention(mtNamingConventionData[0].feature_value);

            let trackEmployeeCostData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 54 } })).data;
            if (trackEmployeeCostData.length > 0)
                trackEmployeeCostData[0].feature_value === 'true' ? setTrackEmployeeCost(true) : setTrackEmployeeCost(false);

            let identifyAnnualVisitSettingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 55 } })).data;
            if (identifyAnnualVisitSettingsData.length > 0)
                identifyAnnualVisitSettingsData[0].feature_value === 'true' ? setIdentifyAnnualVisit(true) : setIdentifyAnnualVisit(false);

            let mtNotificationSettingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 59 } })).data;
            if (mtNotificationSettingsData.length > 0)
                mtNotificationSettingsData[0].feature_value === 'true' ? setMtNotification(true) : setMtNotification(false);

            let taskNotificationSettingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 58 } })).data;
            if (taskNotificationSettingsData.length > 0)
                taskNotificationSettingsData[0].feature_value === 'true' ? setTaskNotification(true) : setTaskNotification(false);

            let createProjectForNewCustomers = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 72 } })).data;
            if (createProjectForNewCustomers.length > 0)
                createProjectForNewCustomers[0].feature_value === 'true' ? setCreateProjectForNewCustomers(true) : setCreateProjectForNewCustomers(false);

            let projectExpiryData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 78 } })).data;
            if (projectExpiryData.length > 0)
                setNeverExpireCustomerProjects(projectExpiryData[0].feature_value === 'true');

        } catch (error) {
            console.error(error);
        }
    }

    const getProcedureData = async () => {
        let dataMaps = await axios.get(APIURL + "/procedureCodes/handleMappingForTaskProcCode", { params: { comp_id: props.comp_id } });
        console.log(dataMaps);
        setProcedureData(dataMaps.data);
    }

    const getCompanyData = async () => {
        let company_detail = await axios.get(APIURL + '/company', { params: { comp_id: props.comp_id } })
        let payrollData = await axios.get(APIURL + '/dropdowns/dropdownType/payrollFrequency', { params: { comp_id: props.comp_id } })
        let payerdata = await axios.get(APIURL + "/payer", { params: { comp_id: props.comp_id } })

        let Company_Dets = { ...company_detail.data[0], com_logo: props.user.company_logo }
        if (Company_Dets.payerId) {
            let Payer_Dets = await axios.get(APIURL + '/payer', { params: { payer_id: Company_Dets.payerId } })
            setPayerDetail(Payer_Dets.data[0] || {})
            let Cred_Data = await axios.get(APIURL + '/creds', { params: { com_id: props.comp_id } })
            setCredDetail(Cred_Data.data[0] || {})
        }
        setCompanyDetail(Company_Dets)
        setPayrollData(payrollData.data)
        setSelectedFrequency(Company_Dets.payCycle)
        setSelectedDay(Company_Dets.startoftheWeek)
        setPayerList(payerdata.data)
    }

    const geBillingData = async () => {
        try {
            const response = await axios.get(APIURL + `/company/v2/billinginfo`, { params: { company_id: props.comp_id } });
            setBillingDetail(response.data)
        } catch (error) {
            console.error(error);
        }
    }

    const getSalaryTypeData = async () => {
        try {
            let salaryType = await axios.get(APIURL + "/dropdowns/dropdownType/salaryType", { params: { comp_id: props.comp_id } });
            setSalaryTypeList(salaryType.data);
        } catch (error) {
            console.error(error);
        }
    }

    const getFrequencyData = async () => {
        try {
            let frequency = await axios.get(APIURL + "/config/defaults", { params: { feature_type: 'payrollFrequency' } });
            setFrequencyList(frequency.data);
        } catch (error) {
            console.error(error);
        }
    }

    const getAgencySettings = async () => {
        try {
            let enableAutomaticPayrollData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 51 } })).data;
            if (enableAutomaticPayrollData.length > 0)
                enableAutomaticPayrollData[0].feature_value === 'true' ? setEnableAutomaticPayroll(true) : setEnableAutomaticPayroll(false);

            let tasksBillableByDefaultData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 56 } })).data;
            if (tasksBillableByDefaultData.length > 0)
                tasksBillableByDefaultData[0].feature_value === 'true' ? setTasksBillableByDefault(true) : setTasksBillableByDefault(false);

            let EVVOnlyData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 71 } })).data;
            if (EVVOnlyData.length > 0)
                EVVOnlyData[0].feature_value === 'true' ? setEVVOnly(true) : setEVVOnly(false);

            let toleranceValData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 57 } })).data;
            if (toleranceValData.length > 0)
                setToleranceVal(toleranceValData[0].feature_value);
            else {
                let addDefaultTolerance = (await axios.post(APIURL + "/config/settings", {
                    feature_value: "300",
                    feature_id: 57,
                    company_id: props.comp_id,
                }))
                let toleranceUpdateResp = (await axios.get(APIURL + "/config/settings", { params: { comp_id: this.props.comp_id, feature_id: 57 } })).data
                setToleranceVal(Number(toleranceUpdateResp[0].feature_value));
            }

            let mileagePayoutRate = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 69 } })).data;
            if (mileagePayoutRate.length > 0) {
                setMileagePayoutRate(mileagePayoutRate[0].feature_value);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const getResourceData = async () => {
        try {
            let resources = await axios.get(APIURL + "/resources/company/" + props.comp_id)
            resources.data = resources.data.filter(resource => resource.resource_is_active === true)
            setResources(resources.data)

            let locations = await axios.get(`${APIURL}/location`, { params: { comp_id: props.comp_id } })
            setLocations(locations.data)

            let contacts = await axios.get(`${APIURL}/contacts?com_id=${props.comp_id}`)
            setContacts(contacts.data)
        } catch (error) {
            console.error(error);
        }
    }

    const getSchedulerHours = async () => {
        try {
            let schedulerHoursData = await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 80 } })
            if (schedulerHoursData.data.length > 0)
                setSchedulerHours(JSON.parse(schedulerHoursData.data[0].feature_value))
        } catch (error) {
            console.error(error);
        }
    }

    const getSecureCommunicationData = async () => {
        try {
            let mtSubmissionData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 60 } })).data;
            if (mtSubmissionData.length > 0)
                mtSubmissionData[0].feature_value === 'true' ? setMtSubmission(true) : setMtSubmission(false);

            let mtRejectedData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 61 } })).data;
            if (mtRejectedData.length > 0)
                mtRejectedData[0].feature_value === 'true' ? setMtRejected(true) : setMtRejected(false);

            let mtApprovedData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 62 } })).data;
            if (mtApprovedData.length > 0)
                mtApprovedData[0].feature_value === 'true' ? setMtApproved(true) : setMtApproved(false);

            let taskAssignedData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 63 } })).data;
            if (taskAssignedData.length > 0)
                taskAssignedData[0].feature_value === 'true' ? setTaskAssigned(true) : setTaskAssigned(false);

            let taskStartTimeApproachingData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 64 } })).data;
            if (taskStartTimeApproachingData.length > 0)
                taskStartTimeApproachingData[0].feature_value === 'true' ? setTaskStartTimeApproaching(true) : setTaskStartTimeApproaching(false);

            let taskEndTimeApproachingData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 65 } })).data;
            if (taskEndTimeApproachingData.length > 0)
                taskEndTimeApproachingData[0].feature_value === 'true' ? setTaskEndTimeApproaching(true) : setTaskEndTimeApproaching(false);

            let enableMessagingToClientsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 66 } })).data;
            if (enableMessagingToClientsData.length > 0)
                enableMessagingToClientsData[0].feature_value === 'true' ? setEnableMessagingToClients(true) : setEnableMessagingToClients(false);

            let enableSoSMessagingData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 67 } })).data;
            if (enableSoSMessagingData.length > 0)
                enableSoSMessagingData[0].feature_value === 'true' ? setEnableSoSMessaging(true) : setEnableSoSMessaging(false);

            let enableMessagingToContactsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 68 } })).data;
            if (enableMessagingToContactsData.length > 0)
                enableMessagingToContactsData[0].feature_value === 'true' ? setEnableMessagingToContacts(true) : setEnableMessagingToContacts(false);

            let taskDescriptionIsMandatoryData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 74 } })).data;
            if (taskDescriptionIsMandatoryData.length > 0)
                taskDescriptionIsMandatoryData[0].feature_value === 'true' ? setTaskDescriptionIsMandatory(true) : setTaskDescriptionIsMandatory(false);

            let timesheetEntryHasNotesData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 75 } })).data;
            if (timesheetEntryHasNotesData.length > 0)
                timesheetEntryHasNotesData[0].feature_value === 'true' ? setTimesheetEntryHasNotes(true) : setTimesheetEntryHasNotes(false);

            let timesheetEntryTypeData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 76 } })).data;
            if (timesheetEntryTypeData.length > 0)
                setTimesheetEntryType(timesheetEntryTypeData[0].feature_value || 'duration');

            let missedClockInData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 83 } })).data;
            if (missedClockInData.length > 0)
                missedClockInData[0].feature_value === 'true' ? setMissedClockIn(true) : setMissedClockIn(false);

            let missedClockOutData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 84 } })).data;
            if (missedClockOutData.length > 0)
                missedClockOutData[0].feature_value === 'true' ? setMissedClockOut(true) : setMissedClockOut(false);
            let taskTravelTimeEnabledData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 81 } })).data;
            if (taskTravelTimeEnabledData.length > 0)
                taskTravelTimeEnabledData[0].feature_value === 'true' ? setTaskTravelTimeEnabled(true) : setTaskTravelTimeEnabled(false);

            let taskExpensesEnabledData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 82 } })).data;
            if (taskExpensesEnabledData.length > 0)
                taskExpensesEnabledData[0].feature_value === 'true' ? setTaskExpensesEnabled(true) : setTaskExpensesEnabled(false);
        } catch (error) {
            console.error(error);
        }
    }

    const getSecureCommunicationData2 = async () => {
        try {
            let mtSubmissionData = (await axios.get(APIURL + "/config/settings/" + props.user.emp_id, { params: { comp_id: props.comp_id, feature_id: 1 } })).data;
            if (mtSubmissionData.length > 0)
                mtSubmissionData[0].feature_value === 'true' ? setMtSubmission2(true) : setMtSubmission2(false);

            let mtRejectedData = (await axios.get(APIURL + "/config/settings/" + props.user.emp_id, { params: { comp_id: props.comp_id, feature_id: 2 } })).data;
            if (mtRejectedData.length > 0)
                mtRejectedData[0].feature_value === 'true' ? setMtRejected2(true) : setMtRejected2(false);

            let mtApprovedData = (await axios.get(APIURL + "/config/settings/" + props.user.emp_id, { params: { comp_id: props.comp_id, feature_id: 3 } })).data;
            if (mtApprovedData.length > 0)
                mtApprovedData[0].feature_value === 'true' ? setMtApproved2(true) : setMtApproved2(false);

            let taskAssignedData = (await axios.get(APIURL + "/config/settings/" + props.user.emp_id, { params: { comp_id: props.comp_id, feature_id: 4 } })).data;
            if (taskAssignedData.length > 0)
                taskAssignedData[0].feature_value === 'true' ? setTaskAssigned2(true) : setTaskAssigned2(false);

            let taskStartTimeApproachingData = (await axios.get(APIURL + "/config/settings/" + props.user.emp_id, { params: { comp_id: props.comp_id, feature_id: 5 } })).data;
            if (taskStartTimeApproachingData.length > 0)
                taskStartTimeApproachingData[0].feature_value === 'true' ? setTaskStartTimeApproaching2(true) : setTaskStartTimeApproaching2(false);

            let taskEndTimeApproachingData = (await axios.get(APIURL + "/config/settings/" + props.user.emp_id, { params: { comp_id: props.comp_id, feature_id: 6 } })).data;
            if (taskEndTimeApproachingData.length > 0)
                taskEndTimeApproachingData[0].feature_value === 'true' ? setTaskEndTimeApproaching2(true) : setTaskEndTimeApproaching2(false);
        } catch (error) {
            console.error(error);
        }
    }

    const getSubscribedFormData = async () => {
        try {
            let subscribedForms = await axios.get(APIURL + "/task_form/subscribed", { params: { company_id: props.comp_id } });
            setSubscribedForms(subscribedForms.data);
            let allForms = await axios.get(APIURL + "/task_form/forms");
            setAllForms(allForms.data?.filter(form => (form.form_company === props.comp_id || form.public_form === true) && form.form_status !== 2));
            console.log(subscribedForms.data, allForms.data?.filter(form => form.form_company === props.comp_id || form.public_form === true))

        } catch (error) {
            console.error(error);
        }
    }

    const getWorkflowData = async () => {
        try {
            const workflowSettings = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 73 } })).data;
            if (workflowSettings.length > 0) {
                setWf_taskCreationDays(workflowSettings[0].feature_value);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const getGridLayout = async () => {
        try {
            const layout = await axios.get(`${APIURL}/gridLayout/forSettings`, {
                params: { companyID: props.comp_id, companyState: props.user.states[0]?.state_id, LineOfBusiness: pBusinessType },
            });
            setLayout(layout.data);
        }
        catch (error) {
            console.error(error);
        }
    }

    return (
        <Box sx={{ mx: 'auto', width: '90%', position: 'relative' }}>
            <Typography variant="h4" gutterBottom>
                Settings
            </Typography>
            <Box sx={{ width: '100%' }}>
                <Tabs value={value} onChange={handleChange}>
                    {props.user.permissions.SettingsGeneralTab && <Tab label="General" value={0} />}
                    {props.user.permissions.SettingsSubscriptionTab && <Tab label="Subscription" value={1} />}
                    {props.user.permissions.SettingsAgencyTab && <Tab label="Agency" value={2} />}
                    {props.user.permissions.SettingsBillingTab && <Tab label="Billing" value={3} />}
                    {props.user.permissions.SettingsAdvancedTab && <Tab label="Advanced" value={5} />}
                    {props.user.permissions.SettingsUserExperienceTab &&
                        <Tab
                            label={
                                <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', width: '100%' }}>
                                    <div>
                                        User Experience
                                    </div>
                                    <div style={{ marginTop: -15, marginLeft: 5 }}>
                                        <PaidOutlined fontSize='small' />
                                    </div>
                                </div>
                            }
                            value={6}
                        />
                    }
                    {props.user.type === 'Admin' && <Tab label="Programs" value={7} />}
                </Tabs>
                <Divider />
                <Section value={value} index={0}>
                    {loadingGeneral ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                            <CircularProgress size={60} />
                        </Box>
                    ) : (
                        <>
                            <SubSection>
                                <PersonalInformation employee={employee} setEmployee={setEmployee} user_id={props.user.emp_id} comp_id={props.comp_id} />
                            </SubSection>
                            <SubSection>
                                <EmploymentInformation employee={employee} setEmployee={setEmployee} empList={empList} levelList={dropdowns.empType} compensationType={dropdowns.compensationType} statusList={dropdowns.empStatus} user_id={props.user.emp_id} comp_id={props.comp_id} type={props.user.type} />
                            </SubSection>
                            <SubSection>
                                <EmployeeTaskType leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user_id={props.user.emp_id} comp_id={props.comp_id} typeList={employeeTaskTypeList} />
                            </SubSection>
                            <SubSection>
                                <SecureCommunication2
                                    mtSubmission={mtSubmission2}
                                    mtRejected={mtRejected2}
                                    mtApproved={mtApproved2}
                                    taskAssigned={taskAssigned2}
                                    taskStartTimeApproaching={taskStartTimeApproaching2}
                                    taskEndTimeApproaching={taskEndTimeApproaching2}
                                    user_id={props.user.emp_id}
                                    comp_id={props.comp_id}
                                    leftColumnSize={leftColumnSize}
                                    rightColumnSize={rightColumnSize}
                                />
                            </SubSection>
                            <SubSection>
                                <ViewEmployeeRelationship
                                    user_id={props.user.emp_id}
                                    comp_id={props.comp_id}
                                    leftColumnSize={leftColumnSize}
                                    rightColumnSize={rightColumnSize}
                                    empList={empList}
                                />
                            </SubSection>
                            {[103, 106].includes(pBusinessType) && (
                                <SubSection>
                                    <CaregiverPreferences employee={employee} com_id={props.comp_id} user={props.user} leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} />
                                </SubSection>
                            )}
                        </>
                    )}
                </Section>
                <Section value={value} index={1}>
                    {loadingSubscription ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                            <CircularProgress size={60} />
                        </Box>
                    ) : (
                        <>
                            <SubSection>
                                <PrimaryBusiness leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} type={primaryBusinessType} user_id={props.user.emp_id} comp_id={props.comp_id} />
                            </SubSection>
                            <SubSection>
                                <States leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} stateList={stateList} selectedStates={selectedStates} user_id={props.user.emp_id} comp_id={props.comp_id} />
                            </SubSection>
                            <SubSection>
                                <ModulesActivated leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} moduleList={moduleList} selectedModules={selectedModules} user_id={props.user.emp_id} comp_id={props.comp_id} />
                            </SubSection>
                        </>
                    )}
                </Section>
                <Section value={value} index={2}>
                    {loadingAgency ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                            <CircularProgress size={60} />
                        </Box>
                    ) : (
                        <>
                            <SubSection>
                                <CompanyInformation setCompanyDetail={setCompanyDetail} companyDetail={companyDetail} payrollData={payrollData} user_id={props.user.emp_id} comp_id={props.comp_id} />
                            </SubSection>
                            <SubSection>
                                <Office user_id={props.user.emp_id} comp_id={props.comp_id} />
                            </SubSection>
                            <SubSection>
                                <SalaryType leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user_id={props.user.emp_id} comp_id={props.comp_id} typeList={salaryTypeList} />
                            </SubSection>
                            <SubSection>
                                <PayrollFrequency leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user_id={props.user.emp_id} comp_id={props.comp_id} frequencyList={frequencyList} selectedFrequency={selectedFrequency} companyDetail={companyDetail} enableAutomaticPayroll={enableAutomaticPayroll} mileagePayoutRate={mileagePayoutRate} setMileagePayoutRate={setMileagePayoutRate} />
                            </SubSection>
                            <SubSection>
                                <StartOfTheWeek leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user_id={props.user.emp_id} comp_id={props.comp_id} selectedDay={selectedDay} companyDetail={companyDetail} />
                            </SubSection>
                            <SubSection>
                                <AgencySettings leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user_id={props.user.emp_id} comp_id={props.comp_id} enableAutomaticPayroll={enableAutomaticPayroll} tasksBillableByDefault={tasksBillableByDefault} EVVOnly={EVVOnly} toleranceVal={toleranceVal} />
                            </SubSection>
                            <SubSection>
                                <ClientSurvey key={props.comp_id} leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user={props.user} comp_id={props.comp_id} customerList={companySurveyCustomers} />
                            </SubSection>
                            <SubSection>
                                <Scheduler leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user_id={props.user.emp_id} comp_id={props.comp_id} schedulerHours={schedulerHours} />
                            </SubSection>
                            <SubSection>
                                <Resource leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user_id={props.user.emp_id} comp_id={props.comp_id} resources={resources} locations={locations} contacts={contacts} />
                            </SubSection>
                            {moduleList?.find((module) => module.feature_value === 'Referral Management') && (
                                <SubSection>
                                    <Referral defaultGuid={companyDetail.com_guid || ''} comp_id={props.comp_id} user_id={props.user.emp_id} leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} empList={empList} />
                                </SubSection>
                            )}
                            {moduleList?.find((module) => module.feature_value === 'Secure Communication') && (
                                <SubSection>
                                    <SecureCommunication
                                        mtSubmission={mtSubmission}
                                        mtRejected={mtRejected}
                                        mtApproved={mtApproved}
                                        taskAssigned={taskAssigned}
                                        taskStartTimeApproaching={taskStartTimeApproaching}
                                        taskEndTimeApproaching={taskEndTimeApproaching}
                                        enableMessagingToClients={enableMessagingToClients}
                                        enableSoSMessaging={enableSoSMessaging}
                                        enableMessagingToContacts={enableMessagingToContacts}
                                        missedClockIn={missedClockIn}
                                        missedClockOut={missedClockOut}
                                        isHomeHealthcare={pBusinessType === 103}
                                        user_id={props.user.emp_id}
                                        comp_id={props.comp_id}
                                        leftColumnSize={leftColumnSize}
                                        rightColumnSize={rightColumnSize}
                                    />
                                </SubSection>
                            )}
                            {props.user.type === 'Admin' && (
                                <SubSection>
                                    <CompanyMessages comp_id={props.comp_id} user={props.user} />
                                </SubSection>
                            )}
                            <SubSection>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Grid container spacing={2}>
                                        <Grid size={4}>
                                            <Stack spacing={1}>
                                                <Typography variant="h5">
                                                    {'Task Configuration'}
                                                </Typography>
                                                <Typography variant="body1" sx={{ color: 'gray' }}>
                                                    {'Configure task and timesheet requirements'}
                                                </Typography>
                                            </Stack>
                                        </Grid>
                                        <Grid size={8}>
                                            <Grid container spacing={2}>
                                                <Grid size={6}>
                                                    <Stack spacing={0}>
                                                        <FormControlLabel
                                                            sx={{ marginTop: 3.5 }}
                                                            control={
                                                                <Checkbox checked={taskDescriptionIsMandatory} onChange={async () => {
                                                                    let newSettingValue = !taskDescriptionIsMandatory;
                                                                    setTaskDescriptionIsMandatory(!taskDescriptionIsMandatory);
                                                                    try {
                                                                        let settingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 74 } })).data;
                                                                        if (settingsData.length > 0) {
                                                                            let settingsPayload = {
                                                                                settings_id: settingsData[0].settings_id, 
                                                                                feature_value: newSettingValue ? 'true' : 'false', 
                                                                                feature_id: 74,
                                                                            }
                                                                            let result = await axios.put(APIURL + `/config/settings`, { ...settingsPayload });
                                                                        } else {
                                                                            let settingsPayload = {
                                                                                feature_value: newSettingValue ? 'true' : 'false',
                                                                                feature_id: 74,
                                                                                company_id: props.comp_id,
                                                                                added_by: props.user.emp_id
                                                                            }
                                                                            let result = await axios.post(APIURL + `/config/settings`, { ...settingsPayload });
                                                                        }
                                                                    } catch (error) {
                                                                        console.error(error);
                                                                    }
                                                                }}
                                                                    name={'taskDescriptionIsMandatory'} />
                                                            }
                                                            label={'Task Description Is Mandatory'}
                                                        />
                                                        <FormControlLabel
                                                            sx={{ marginTop: 0 }}
                                                            control={
                                                                <Checkbox checked={timesheetEntryHasNotes} onChange={async () => {
                                                                    let newSettingValue = !timesheetEntryHasNotes;
                                                                    setTimesheetEntryHasNotes(!timesheetEntryHasNotes);
                                                                    try {
                                                                        let settingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 75 } })).data;
                                                                        if (settingsData.length > 0) {
                                                                            let settingsPayload = {
                                                                                settings_id: settingsData[0].settings_id, 
                                                                                feature_value: newSettingValue ? 'true' : 'false', 
                                                                                feature_id: 75,
                                                                            }
                                                                            let result = await axios.put(APIURL + `/config/settings`, { ...settingsPayload });
                                                                        } else {
                                                                            let settingsPayload = {
                                                                                feature_value: newSettingValue ? 'true' : 'false',
                                                                                feature_id: 75,
                                                                                company_id: props.comp_id,
                                                                                added_by: props.user.emp_id
                                                                            }
                                                                            let result = await axios.post(APIURL + `/config/settings`, { ...settingsPayload });
                                                                        }
                                                                    } catch (error) {
                                                                        console.error(error);
                                                                    }
                                                                }}
                                                                    name={'timesheetEntryHasNotes'} />
                                                            }
                                                            label={'Timesheet Entry Has Notes'}
                                                        />
                                                        <FormControlLabel
                                                            sx={{ marginTop: 0 }}
                                                            control={
                                                                <Checkbox checked={taskTravelTimeEnabled} onChange={async () => {
                                                                    let newSettingValue = !taskTravelTimeEnabled;
                                                                    setTaskTravelTimeEnabled(!taskTravelTimeEnabled);
                                                                    try {
                                                                        let settingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 81 } })).data;
                                                                        if (settingsData.length > 0) {
                                                                            let settingsPayload = {
                                                                                settings_id: settingsData[0].settings_id, 
                                                                                feature_value: newSettingValue ? 'true' : 'false', 
                                                                                feature_id: 81,
                                                                            }
                                                                            let result = await axios.put(APIURL + `/config/settings`, { ...settingsPayload });
                                                                        } else {
                                                                            let settingsPayload = {
                                                                                feature_value: newSettingValue ? 'true' : 'false',
                                                                                feature_id: 81,
                                                                                company_id: props.comp_id,
                                                                                added_by: props.user.emp_id
                                                                            }
                                                                            let result = await axios.post(APIURL + `/config/settings`, { ...settingsPayload });
                                                                        }
                                                                    } catch (error) {
                                                                        console.error(error);
                                                                    }
                                                                }}
                                                                    name={'taskTravelTimeEnabled'} />
                                                            }
                                                            label={'Task Travel Time Enabled'}
                                                        />
                                                        <FormControlLabel
                                                            sx={{ marginTop: 0 }}
                                                            control={
                                                                <Checkbox checked={taskExpensesEnabled} onChange={async () => {
                                                                    let newSettingValue = !taskExpensesEnabled;
                                                                    setTaskExpensesEnabled(!taskExpensesEnabled);
                                                                    try {
                                                                        let settingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 82 } })).data;
                                                                        if (settingsData.length > 0) {
                                                                            let settingsPayload = {
                                                                                settings_id: settingsData[0].settings_id, 
                                                                                feature_value: newSettingValue ? 'true' : 'false', 
                                                                                feature_id: 82,
                                                                            }
                                                                            let result = await axios.put(APIURL + `/config/settings`, { ...settingsPayload });
                                                                        } else {
                                                                            let settingsPayload = {
                                                                                feature_value: newSettingValue ? 'true' : 'false',
                                                                                feature_id: 82,
                                                                                company_id: props.comp_id,
                                                                                added_by: props.user.emp_id
                                                                            }
                                                                            let result = await axios.post(APIURL + `/config/settings`, { ...settingsPayload });
                                                                        }
                                                                    } catch (error) {
                                                                        console.error(error);
                                                                    }
                                                                }}
                                                                    name={'taskExpensesEnabled'} />
                                                            }
                                                            label={'Task Expenses Enabled'}
                                                        />
                                                    </Stack>
                                                </Grid>
                                                <Grid size={6}>
                                                    <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
                                                        {'Timesheet Entry Storage Type'}
                                                    </Typography>
                                                    <RadioGroup
                                                        value={timesheetEntryType}
                                                        onChange={async (e) => {
                                                                let newValue = e.target.value;
                                                                setTimesheetEntryType(newValue);
                                                                try {
                                                                    let settingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 76 } })).data;
                                                                    if (settingsData.length > 0) {
                                                                        let settingsPayload = {
                                                                            settings_id: settingsData[0].settings_id,
                                                                            feature_value: newValue,
                                                                            feature_id: 76,
                                                                        }
                                                                        await axios.put(APIURL + `/config/settings`, { ...settingsPayload });
                                                                    } else {
                                                                        let settingsPayload = {
                                                                            feature_value: newValue,
                                                                            feature_id: 76,
                                                                            company_id: props.comp_id,
                                                                            added_by: props.user.emp_id
                                                                        }
                                                                        await axios.post(APIURL + `/config/settings`, { ...settingsPayload });
                                                                    }
                                                                } catch (error) {
                                                                    console.error(error);
                                                                }
                                                            }}
                                                        >
                                                        <FormControlLabel value="duration" control={<Radio />} label="Store Duration Only" />
                                                        <FormControlLabel value="exact_times" control={<Radio />} label="Store Exact Times (Start & End)" />
                                                    </RadioGroup>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </SubSection>
                        </>
                    )}
                    {value === 2 && props.user.permissions.SettingsAgencyTab && (
                        <Compliance key={props.comp_id} comp_id={props.comp_id} user_id={props.user.emp_id} />
                    )}
                </Section>
                <Section value={value} index={3}>
                    {loadingBilling ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                            <CircularProgress size={60} />
                        </Box>
                    ) : (
                        <>
                            <SubSection>
                                <BillingInformation comp_id={props.comp_id} billingDetail={billingDetail} />
                            </SubSection>
                            <SubSection>
                                <BillingSettings comp_id={props.comp_id} user_id={props.user.emp_id} />
                            </SubSection>
                            <SubSection>
                                <PayerInformationv2 comp_id={props.comp_id} user_id={props.user.emp_id} />
                            </SubSection>
                            <SubSection>
                                <Provider comp_id={props.comp_id} user_id={props.user.emp_id} />
                            </SubSection>
                        </>
                    )}
                </Section>
                <Section value={value} index={5}>
                    {loadingAdvanced ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                            <CircularProgress size={60} />
                        </Box>
                    ) : (
                        <>
                            <SubSection>
                                <ContactType leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user_id={props.user.emp_id} comp_id={props.comp_id} typeList={contactTypeList} getContactTypeData={getContactTypeData} />
                            </SubSection>
                            <SubSection>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Grid container spacing={2}>
                                        <Grid size={4}>
                                            <Stack spacing={1}>
                                                <Typography variant="h5">
                                                    {'Customer Settings'}
                                                </Typography>
                                                <Typography variant="body1" sx={{ color: 'gray' }}>
                                                    {'Other Customer related settings'}
                                                </Typography>
                                            </Stack>
                                        </Grid>
                                        <Grid size={8}>
                                            <Stack spacing={1}>
                                                <Box>
                                                    <FormControlLabel
                                                        sx={{ height: 25, marginTop: 2, marginLeft: '' }}
                                                        control={
                                                            <Checkbox checked={createProjectForNewCustomers} onChange={async () => {
                                                                let newSettingValue = !createProjectForNewCustomers;
                                                                setCreateProjectForNewCustomers(!createProjectForNewCustomers);
                                                                try {
                                                                    let settingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 72 } })).data;
                                                                    if (settingsData.length > 0) {
                                                                        let settingsPayload = {
                                                                            settings_id: settingsData[0].settings_id, feature_value: newSettingValue ? 'true' : 'false', feature_id: 72,
                                                                        }
                                                                        let result = await axios.put(APIURL + `/config/settings`, { ...settingsPayload });
                                                                    } else {
                                                                        let settingsPayload = {
                                                                            feature_value: newSettingValue ? 'true' : 'false',
                                                                            feature_id: 72,
                                                                            company_id: props.comp_id,
                                                                            added_by: props.user_id
                                                                        }
                                                                        let result = await axios.post(APIURL + `/config/settings`, { ...settingsPayload });
                                                                        let createProjectForNewCustomers = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 72 } })).data;
                                                                        if (createProjectForNewCustomers.length > 0)
                                                                            createProjectForNewCustomers[0].feature_value === 'true' ? setCalendarNotifications(true) : setCalendarNotifications(false);
                                                                    }
                                                                } catch (error) {
                                                                    console.error(error);
                                                                }
                                                            }}
                                                                name={'createProjectForNewCustomers'} />
                                                        }
                                                        label={'Create Project for New Customers'}
                                                    />
                                                </Box>
                                                <Box>
                                                    <FormControlLabel
                                                        sx={{ height: 25, marginTop: 2, marginLeft: '' }}
                                                        control={
                                                            <Checkbox checked={neverExpireCustomerProjects} onChange={async () => {
                                                                let newSettingValue = !neverExpireCustomerProjects;
                                                                setNeverExpireCustomerProjects(newSettingValue);
                                                                try {
                                                                    let settingsData = (await axios.get(APIURL + "/config/settings", { params: { comp_id: props.comp_id, feature_id: 78 } })).data;
                                                                    if (settingsData.length > 0) {
                                                                        let settingsPayload = {
                                                                            settings_id: settingsData[0].settings_id, feature_value: newSettingValue ? 'true' : 'false', feature_id: 78,
                                                                        }
                                                                        await axios.put(APIURL + `/config/settings`, { ...settingsPayload });
                                                                    } else {
                                                                        let settingsPayload = {
                                                                            feature_value: newSettingValue ? 'true' : 'false',
                                                                            feature_id: 78,
                                                                            company_id: props.comp_id,
                                                                            added_by: props.user_id
                                                                        }
                                                                        await axios.post(APIURL + `/config/settings`, { ...settingsPayload });
                                                                    }
                                                                } catch (error) {
                                                                    console.error(error);
                                                                }
                                                            }}
                                                                name={'neverExpireCustomerProjects'} />
                                                        }
                                                        label={'Never Expire Customer Projects'}
                                                    />
                                                </Box>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </SubSection>
                            <SubSection>
                                <CustomerType leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user_id={props.user.emp_id} comp_id={props.comp_id} typeList={customerTypeList} />
                            </SubSection>
                            <SubSection>
                                <EmployeeStatus leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user_id={props.user.emp_id} comp_id={props.comp_id} typeList={employeeStatusList} />
                            </SubSection>
                            <SubSection>
                                <EmpType leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user={props.user} user_id={props.user.emp_id} comp_id={props.comp_id} getProcedureData={getProcedureData} getTaskTypeData={getTaskTypeData} empTypeList={employeeTypeList} procList={procList} formList={formList} providerList={providerList} officeList={officeList} payerList={payerList} procedureData={procedureData} />
                            </SubSection>
                            <SubSection>
                                <Form leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user_id={props.user.emp_id} comp_id={props.comp_id} subscribedForms={subscribedForms} allForms={allForms} setAllForms={setAllForms} />
                            </SubSection>
                            <SubSection>
                                <LocationType leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user_id={props.user.emp_id} comp_id={props.comp_id} typeList={locationTypeList} />
                            </SubSection>
                            <SubSection>
                                <IndividualSettings
                                    mtNamingConvention={mtNamingConvention}
                                    mtNA={mtNA}
                                    calendarNotifications={calendarNotifications}
                                    trackEmployeeCost={trackEmployeeCost}
                                    identifyAnnualVisit={identifyAnnualVisit}
                                    mtNotification={mtNotification}
                                    taskNotification={taskNotification}
                                    user_id={props.user.emp_id}
                                    comp_id={props.comp_id}
                                    leftColumnSize={leftColumnSize}
                                    rightColumnSize={rightColumnSize}
                                />
                            </SubSection>
                            <SubSection>
                                <TaskType
                                    leftColumnSize={leftColumnSize}
                                    rightColumnSize={rightColumnSize}
                                    user_id={props.user.emp_id}
                                    comp_id={props.comp_id}
                                    getProcedureData={getProcedureData}
                                    getTaskTypeData={getTaskTypeData}
                                    taskTypeList={taskTypeList}
                                    procList={procList}
                                    formList={formList}
                                    providerList={providerList}
                                    officeList={officeList}
                                    payerList={payerList}
                                    procedureData={procedureData}
                                    adlCatalog={adlCatalog}
                                    adlCatalogLoading={adlCatalogLoading}
                                    adlCatalogError={adlCatalogError}
                                    onAdlCatalogRetry={getAdlCatalogData}
                                    initialSelectedAdls={adlLinks}
                                    adlLinksLoading={adlLinksLoading}
                                    adlLinksError={adlLinksError}
                                    onAdlLinksRetry={getAdlLinksData}
                                />
                            </SubSection>
                            <SubSection>
                                <Grid container spacing={2}>
                                    <Grid size={leftColumnSize}>
                                        <Stack spacing={1}>
                                            <Typography variant="h5">Task Type Mappings</Typography>
                                            <Typography variant="body1" sx={{ color: 'gray' }}>
                                                View mappings of task types to standard descriptions and codes
                                            </Typography>
                                        </Stack>
                                    </Grid>
                                    <Grid size={rightColumnSize}>
                                        <EvvProcedure data={procedureData} user={props.user} emp_id={props.user.emp_id} comp_id={props.comp_id} />
                                    </Grid>
                                </Grid>
                            </SubSection>
                            <SubSection>
                                <Grid container spacing={2}>
                                    <Grid size={leftColumnSize}>
                                        <Stack spacing={1}>
                                            <Typography variant="h5">Task Billing Rates</Typography>
                                            <Typography variant="body1" sx={{ color: 'gray' }}>
                                                View rates for mapped procedure codes
                                            </Typography>
                                        </Stack>
                                    </Grid>
                                    <Grid size={rightColumnSize}>
                                        <TaskBillingRatesGrid user={props.user} comp_id={props.comp_id} />
                                    </Grid>
                                </Grid>
                            </SubSection>
                            <SubSection>
                                <Workflow leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} user_id={props.user.emp_id} comp_id={props.comp_id} wf_taskCreationDays={wf_taskCreationDays} setWf_taskCreationDays={setWf_taskCreationDays} />
                            </SubSection>
                        </>
                    )}
                </Section>
                <Section value={value} index={6}>
                    {loadingUserExperience ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                            <CircularProgress size={60} />
                        </Box>
                    ) : (
                        <>
                            <SubSection>
                                <HomePageLayout leftColumnSize={leftColumnSize} rightColumnSize={rightColumnSize} loadUserExperienceData={loadUserExperienceData} user={props.user} layout={layout} employeeTypeList={employeeTypeList} />
                            </SubSection>
                        </>
                    )}
                </Section>
                {props.user.type === 'Admin' && (
                    <Section value={value} index={7}>
                        <Programs comp_id={props.comp_id} user={props.user} />
                    </Section>
                )}
            </Box>
        </Box>
    );
}

export default Settings;
